<template>
  <div class="select">
    <select
      ref="selectEle"
      style="
        float: left;
        z-index: 1;
        position: relative;
        width: 100%;
        height: 100%;
        background-color: transparent;
        color: inherit;
        outline: inherit;
        border: 0;
        font-size: inherit;
      "
      v-model="selectValue"
      :disabled="disabled"
      :class="[
        {
          'placeholder-style': value == undefined || disabled
        },
        pointClass
      ]"
      @change="onSelect($event.target.value)"
    >
      <option v-if="placeholder" disabled selected :value="undefined">
        {{ placeholder }}
      </option>
      <slot></slot>
    </select>
    <van-icon
      class="select-arrow"
      :class="{
        'placeholder-style': disabled
      }"
      name="arrow-down"
    />
  </div>
</template>

<script>
export default {
  name: 'Select',
  mixins: ['update:value', 'change'],
  props: {
    value: {
      type: [String, Number],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    pointClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.selectValue = newValue;
    }
  },
  methods: {
    onSelect(value) {
      this.$emit('update:value', value);
      this.$emit('change', value);
      const selectEle = this.$refs.selectEle;
      selectEle && typeof selectEle.blur === 'function' && selectEle.blur();
    },
    // 这里和上面的blur，主要是为了避免在选中select的时候切换屏幕再回来时会自动触发聚焦上报。
    selectAutoBlur() {
      if (document?.visibilityState == 'hidden') {
        try {
          const selectElem = this.$refs.selectEle;
          selectElem &&
            typeof selectElem.blur === 'function' &&
            selectElem.blur();
        } catch (error) {
          console.log(error);
        }
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.selectAutoBlur);
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.selectAutoBlur);
  }
};
</script>

<style lang="scss">
.select {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  padding: 0 62px 0 20px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);
  font-size: 24px;
  color: var(--text-color);

  > select {
    &:disabled {
      color: var(--placeholder-color) !important;
      -webkit-text-fill-color: var(--placeholder-color) !important;
    }
  }

  .placeholder-style {
    color: var(--placeholder-color) !important;
  }

  &-arrow {
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 22px;
    bottom: 0;
    margin: auto;
    font-weight: bold;
    color: var(--back-color);
  }
}
</style>
